

































import { Vue, Component, Prop } from "vue-property-decorator";
import { IMenuRoute } from "@/models/routes";

@Component
export default class Tabigation extends Vue {
  // Props

  @Prop({ required: true })
  public routes!: IMenuRoute[];

  @Prop({ default: 0 })
  public skeletonCount!: number;

  @Prop({ default: false })
  public isLoading!: boolean;

  // Computed

  public get vm() {
    return this;
  }

  public get availableRoutes() {
    return this.$_.filter(this.routes, route => {
      return this.$_.get(route, "if", () => true)(this);
    });
  }

  // Methods

  public tabIsActive(route: IMenuRoute, isActive: boolean) {
    return route.isActive
      ? route.isActive(this.$router.currentRoute, isActive)
      : isActive;
  }
}
